import React, { useEffect, useState } from "react";
import { Comment } from "@/components";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { checkResult, createFilePath, second2DateTime } from "@/common";
import "./style.less";

function CommentList(props) {

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [comments, setComments] = useState([]);

    useEffect(() => {
        getComments(props.itemId, props.type)
    }, [])

    // 查询评论
    const getComments = (id, type) => {
        BaseService.list({
            table: "thtt_comment",
            columns: "comment_id,content,add_time AS addTime, like_amount",
            leftJoin: {
                table: "thtt_user",
                on: "thtt_comment.add_user = thtt_user.user_id",
                columns: ["nickname AS name", "avatar AS head"]
            },
            where: { "thtt_comment.item_id": id, "thtt_comment.item_type": type },
            order: ["thtt_comment.add_time DESC"]
        }).then(res => {
            if (!checkResult(res)) return;
            setComments(res.data.result.map(vo => ({
                ...vo,
                addTime: second2DateTime(vo.addTime),
                head: createFilePath(vo.head, UPLOAD_SERVER_HOST),
            })));
        })
    }

    return (
        <Comment className={props.className} data={comments} />
    )
}

export default CommentList;